/**
 * FilterTraitType
 */
import { getTraitTypeAttributes } from "@bkry/bowline-redux/traitTypes";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
// import { MultiRangeSlider } from "../../../MultiRangeSlider";
import FilterTraitTypeTrait from "./FilterTraitTypeTrait";

/**
 * FilterTraitType used in TokenTraitFilter
 */
const FilterTraitType = (props) => {
  const { traitTypeId, handleFilterChange, filters } = props;
  const traitTypeData = useSelector((state) =>
    getTraitTypeAttributes(state, traitTypeId)
  );

  const selectedFiltersCount = filters ? filters[traitTypeId]?.split("%2C").length || 0 : 0;

  if (!!Object.keys(traitTypeData.trait_values).length <= 0) return null;
  let selectedFilters = filters
    ? filters[traitTypeId]?.split("%2C").map((u) => u.replace("+", " ")) || []
    : [];

  const handleChange = (traitName, value) => {
    switch (traitTypeData.display_type) {
      default:
        if (selectedFilters.includes(traitName)) {
          selectedFilters = selectedFilters.filter((n) => n !== traitName);
        } else {
          selectedFilters.push(traitName);
        }
        handleFilterChange(selectedFilters, traitTypeId);
    }
  };

  const renderTraitFilters = () => {
    switch (traitTypeData.display_type) {
      /* TODO: for now we ALWAYS use the default case with checkbox filter
       * We need to change the cases for types again
       * once our api can handle min max values for thos
       */
      // case "boost_percentage":
      //   return (
      //     <MultiRangeSlider
      //       min={0}
      //       max={100}
      //       onChange={(values) => {
      //         console.log("TODO: FILTER BY RANGE", values);
      //       }}
      //     />
      //   );
      // case "boost_number":
      //   const boostNumberValues = Object.keys(traitTypeData.trait_values).map((n) =>
      //     parseInt(n)
      //   );
      //   // TODO: get the right min and max values
      //   const boostSliderMin = Math.min(...boostNumberValues);
      //   const boostSliderMax = Math.max(...boostNumberValues);
      //   return (
      //     <MultiRangeSlider
      //       min={boostSliderMin}
      //       max={boostSliderMax}
      //       onChange={(values) => {
      //         console.log("TODO: FILTER BY RANGE", values);
      //       }}
      //     />
      //   );
      // case "number":
      //   // TODO: get the right min and max values
      //   const numberValues = Object.keys(traitTypeData.trait_values).map((n) => parseInt(n));
      //   const numberSliderMin = Math.min(...numberValues);
      //   const numberSliderMax = Math.max(...numberValues);
      //   return (
      //     <MultiRangeSlider
      //       min={numberSliderMin}
      //       max={numberSliderMax}
      //       onChange={(values) => {
      //         console.log("TODO: FILTER BY RANGE", values);
      //       }}
      //     />
      //   );
      // case "date" and case "string"
      default:
        return (
          <>
            {Object.keys(traitTypeData?.trait_values).map((trait, idx) => (
              <FilterTraitTypeTrait
                key={trait}
                trait={trait}
                amount={traitTypeData.trait_values[trait]}
                traitTypeId={traitTypeId}
                inputId={`${traitTypeId}-${idx}`}
                handleChange={handleChange}
                selected={selectedFilters.includes(trait)}
              />
            ))}
          </>
        );
    }
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId={traitTypeId}>
        <div className="flex-grow-1 d-flex justify-content-between me-3">
          <span className="fw-bold">{traitTypeData.name}</span>
          {selectedFiltersCount > 0 && <span>{selectedFiltersCount}</span>}
        </div>
      </AccordionHeader>
      <AccordionBody accordionId={traitTypeId}>
        {renderTraitFilters()}
      </AccordionBody>
    </AccordionItem>
  );
};

FilterTraitType.propTypes = {
  traitTypeId: PropTypes.string.isRequired,
  handleFilterChange: PropTypes.func,
};

/**  define proptype for the 'translation' function  */
FilterTraitType.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default FilterTraitType;
